// Tells Mac users, on landing after sign-in, that the Medsender Printer Driver
// now ships for Mac (ENG-3479). It is a short-lived announcement, so nothing is
// stored server side: "don't show this again" lives in this browser's
// localStorage, and a per-tab sessionStorage marker keeps it from reappearing on
// every visit to Home once it has been seen.

import { isSupportedMacDevice } from './printerDriverDownload';

export const MAC_PRINTER_DRIVER_ANNOUNCEMENT_DISMISSED_KEY = 'm8_hideMacPrinterDriverAnnouncement';
export const MAC_PRINTER_DRIVER_ANNOUNCEMENT_SHOWN_KEY = 'm8_macPrinterDriverAnnouncementShown';

// Sign-out wipes every m8_ key, so the dismissal would come back at the next
// login. `actions/auth.js#resetAuth` passes this as `preserveKeys`. Keeping it
// across accounts is safe: it records that this Mac was told about the driver,
// not who was signed in.
export const PRESERVED_MAC_PRINTER_DRIVER_ANNOUNCEMENT_KEYS = new Set([
  MAC_PRINTER_DRIVER_ANNOUNCEMENT_DISMISSED_KEY,
]);

// Storage can be unavailable (private windows, blocked site data); treat that as
// "nothing remembered" rather than letting it break Home.
const readFlag = (storage, key) => {
  try {
    return storage.getItem(key) === 'true';
  } catch {
    return false;
  }
};

const writeFlag = (storage, key) => {
  try {
    storage.setItem(key, 'true');
  } catch {
    // Nothing to remember it in; the announcement may show again.
  }
};

export const shouldShowMacPrinterDriverAnnouncement = (navigatorObject = window.navigator) => (
  isSupportedMacDevice(navigatorObject)
  && !readFlag(window.localStorage, MAC_PRINTER_DRIVER_ANNOUNCEMENT_DISMISSED_KEY)
  && !readFlag(window.sessionStorage, MAC_PRINTER_DRIVER_ANNOUNCEMENT_SHOWN_KEY)
);

export const markMacPrinterDriverAnnouncementShown = () => (
  writeFlag(window.sessionStorage, MAC_PRINTER_DRIVER_ANNOUNCEMENT_SHOWN_KEY)
);

export const dismissMacPrinterDriverAnnouncement = () => (
  writeFlag(window.localStorage, MAC_PRINTER_DRIVER_ANNOUNCEMENT_DISMISSED_KEY)
);
